module.exports = __webpack_public_path__ + "fonts/Poppins-ThinItalic.c93e22e9.ttf";